import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import './collaborativeIndexationCreation.css'
import Header from '../Aside/Header'
import { NominativeFormContainer } from './Forms/Nominative/NominativeForm'
import { NominativeWithDateFormContainer } from './Forms/NominativeWithDate/NominativeWithDateForm'
import { FrenchCivilRegistryFormContainer } from './Forms/FrenchCivilRegistry/FrenchCivilRegistryForm'
import { CollaborativeIndexationContainer } from '../../Disclaimers/CollaborativeIndexation/CollaborativeIndexation'
import { FrenchMilitaryRecordFormContainer } from './Forms/FrenchMilitaryRecord/FrenchMilitaryRecordForm'
import { PopulationCensusFormContainer } from './Forms/PopulationCensus/PopulationCensusForm'
import Confirmation from '../../Modal/Confirmation'


class CollaborativeIndexationCreation extends Component {

    static propTypes = {
        t: PropTypes.func.isRequired,
        close: PropTypes.func.isRequired,
        indexationType: PropTypes.string,
        isUserCollaborativeIndexerStatusActive: PropTypes.bool.isRequired,
        isCloseConfirmationNeeded: PropTypes.bool.isRequired,
        confirmClose: PropTypes.func.isRequired,
        cancelClose: PropTypes.func.isRequired,
    }

    constructor(props)
    {
        super(props)
        this.renderForm = this.renderForm.bind(this)

        this.forms = {
            nominative: <NominativeFormContainer />,
            nominative_with_date: <NominativeWithDateFormContainer />,
            french_civil_registry: <FrenchCivilRegistryFormContainer />,
            french_military_record: <FrenchMilitaryRecordFormContainer />,
            population_census: <PopulationCensusFormContainer />,
        }
    }

    renderForm()
    {
        const { indexationType } = this.props
        if(this.forms.hasOwnProperty(indexationType))
        {
            return this.forms[indexationType]
        }

        return null
    }

    render()
    {
        const { close, confirmClose, cancelClose, t } = this.props

        if(! this.props.isUserCollaborativeIndexerStatusActive)
        {
            return <CollaborativeIndexationContainer />
        }

        return (
            <React.Fragment>
                {
                    this.props.isCloseConfirmationNeeded && <Confirmation
                        title={t('visualizer:toolbar.left.collaborativeIndexationCreation.closeConfirmation.title')}
                        content={t('visualizer:toolbar.left.collaborativeIndexationCreation.closeConfirmation.content')}
                        confirm={confirmClose}
                        cancel={cancelClose}
                    />
                }
                <div className="collaborative-indexations-creation">
                    <Header
                        className='collaborative-indexations-creation-header'
                        close={close}
                        title={t('visualizer:toolbar.left.collaborativeIndexationCreation.title')}
                    />
                    {this.renderForm()}
                </div>
            </React.Fragment>
        )
    }
}

export default withTranslation()(CollaborativeIndexationCreation)
